import {
  configureStore,
  combineReducers,
  ThunkDispatch,
  Action,
} from '@reduxjs/toolkit';
import activeRequest from './ActiveRequest/activeRequestSlice';
import { DashboardAPI } from 'api/normalized/dashboard/dashboardAPI';
import { AgentDashboardApi } from 'api/normalized/agentDashboard/agentDashboardAPI';
import { CardTypeApi } from 'state/Insights/charts/cardTypeApi';
import forms from './Forms/formSlice';
import inlineNotification from './InlineNotification/inlineNotificationSlice';
import requestsState from './Requests/requestSlice';
import projectsState from './Projects/projectsSlice';
import project from './Project/projectSlice';
import projectComments from './ProjectComments/projectCommentsSlice';
import currentUser from './User/userSlice';
import userSettings from './UserSetting/userSettingsSlice';
import requestComments from './RequestComments/requestCommentsSlice';
import users from './UsersManagement/usersManagementSlice';
import teams from './Teams/teamsSlice';
import organization from './Organization/organizationSlice';
import processes from './Processes/processesSlice';
import notifications from './Notifications/notificationsSlice';
import notificationSettings from './NotificationSettings/notificationSettingsSlice';
import timeOff from './TimeOff/TimeOffSlice';
import singleTask from './SingleTask/singleTaskSlice';
import projectTasks from './ProjectTasks/projectTaskSlice';
import tasks from './Tasks/taskSlice';
import vendors from './Vendors/vendorsSlice';
import businessTeams from './BusinessTeams/businessTeamsSlice';
import learningTeams from './LearningTeams/learningTeamsSlice';
import learningTeam from './LearningTeam/learningTeamSlice';
import budgets from './Budget/budgetSlice';
import capacity from './Capacity/capacitySlice';
import capacities from './Capacities';
import resourceAllocation from './ResourceAllocation/resourceAllocation';
import designs from './Designs/designsSlice';
import myWorkspace from './MyWorkspace/myWorkspaceSlice';
import sidePanel from './SidePanel/sidePanelSlice';
import sidekick from './Sidekick/sidekickSlice';
import projectTemplates from './ProjectTemplates/projectTemplatesSlice';
import projectTemplate from './ProjectTemplate/ProjectTemplateSlice';
import programs from './Programs/programsSlice';
import program from './Program/programSlice';
import programStrategy from './ProgramStrategy/programStrategySlice';
import snackbarNotification from './SnackbarNotification/SnackbarNotificationSlice';
import filtersSettings from './Settings/Filters/FiltersSlice';
import tasksAssignmentsResourcesCapacity from './TasksAssignmentsResourcesCapacity/tasksAssignmentsResourcesCapacitySlice';
import projectsInsights from './Insights/ProjectsSlice';
import intakeInsights from './Insights/InsightsSlice';
import customFields from './CustomFields/customFieldsSlice';
import taskBundles from 'state/TasksBundle/tasksBundleSlice';
import activeTaskBundle from './ActiveTaskBundle/activeTaskBundleSlice';
import teamsCapacity from './TeamsCapacity/teamsCapacitySlice';
import capacityInsights from './Insights/capacitySlice';
import programCategory from './StrategyCategory/strategyCategorySlice';
import dailyTeamsCapacity from './DailyTeamsCapacity';
import weeklyTeamsCapacity from './WeeklyTeamCapacity';
import objectiveMeasurement from './ObjectiveMeasurementSlice/objectiveMeasurementSlice';
import monetaryBenefits from './MonetaryBenefits/monetaryBenefitsSlice';
import measurementScales from './MeasurementScales/measurementScalesSlice';
import viewSettings from './ViewSettings/viewSettingsSlice';
import additionalBenefit from './AdditionalBenefit/additionalBenefitSlice';
import manageTimeOff from './ManageTimeOff';
import programInput from './ProgramInputCategoy/ProgramInputCategoySlice';
import roiCategory from './ROICategory/ROICategoySlice';
import roiCosts from './ROICosts/ROICostsSlice';
import tasksList from './TasksList';
import projectTasksList from './ProjectTasksList';
import { useDispatch } from 'react-redux';
import taskDetail from './TaskDetail/taskSlice';
import schedule from './Schedule/ScheduleSlice';
import actualHours from './ActualHours/actualHoursSlice';
import linkedTaskContent from './LinkedTaskContent/linkedTaskContentSlice';
import projectProgress from './Project/progress/progressSlice';
import evaluations from './Evaluations/evaluationsSlice';
import evaluationInsights from './Evaluations/evaluationInsightsSlice';
import instructors from './Evaluations/instructorsSlice';
import taskDependencies from './TaskDependencies/TaskDependenciesSlice';
import dependenciesUpdate from './TaskDependencies/DependenciesUpdateSlice';
import strategyGoals from './StrategyGoals/StrategyGoalsSlice';
import singleStrategyGoal from './SingleStrategyGoal/SingleStrategyGoalSlice';
import yearTimePeriod from './YearTimePeriods/YearTimePeriodSlice';
import normalized from './normalized/reducers';
import {
  BaseApiFactory,
  RequestsApi,
  UserSummariesApi,
  FormSummariesApi,
  ProjectSummariesApi,
  ProjectPermissionsApi,
  BusinessUnitSummariesApi,
  RequestPermissionsApi,
  EventPermissionsApi,
  ProgramPermissionsApi,
} from 'api';
import projectGoals from './ProjectGoals/ProjectGoalsSlice';
import projectPermissions from './Project/permissions/projectPermissionsSlice';
import goalProjects from './GoalProjects/GoalProjectsSlice';
import projectsList from './ProjectsList';
import projectOwners from './ProjectOwners/projectOwnersSlice';
import budgetList from './BudgetList/budgetListSlice';
import exportRequests from './ExportRequests/ExportRequestsSlice';
import navigation from './Navigation/navigationSlice';
import InsightDataApi from 'api/normalized/insight/InsightDataApi';
import insightFiltersAPI from 'api/normalized/insight/insightFiltersAPI';
import InsightDrilldownApi from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import LearningTeamsApi from 'api/normalized/learningTeams';
import ProjectTemplatesApi from 'api/normalized/projectTemplates';

export const rootReducer = combineReducers({
  activeRequest,
  activeTaskBundle,
  actualHours,
  budgets,
  budgetList,
  businessTeams,
  capacity,
  capacities,
  capacityInsights,
  currentUser,
  customFields,
  dailyTeamsCapacity,
  designs,
  evaluations,
  evaluationInsights,
  filtersSettings,
  forms,
  inlineNotification,
  instructors,
  intakeInsights,
  learningTeams,
  learningTeam,
  measurementScales,
  myWorkspace,
  navigation,
  notifications,
  notificationSettings,
  objectiveMeasurement,
  monetaryBenefits,
  organization,
  processes,
  program,
  programCategory,
  programs,
  programStrategy,
  project,
  projectComments,
  projectsInsights,
  projectsState,
  projectTasks,
  projectTemplate,
  projectTemplates,
  requestComments,
  requestsState,
  resourceAllocation,
  sidekick,
  sidePanel,
  singleTask,
  snackbarNotification,
  taskBundles,
  tasks,
  tasksAssignmentsResourcesCapacity,
  teams,
  teamsCapacity,
  timeOff,
  users,
  userSettings,
  vendors,
  viewSettings,
  weeklyTeamsCapacity,
  additionalBenefit,
  manageTimeOff,
  programInput,
  roiCategory,
  roiCosts,
  tasksList,
  taskDetail,
  schedule,
  linkedTaskContent,
  projectTasksList,
  projectProgress,
  taskDependencies,
  dependenciesUpdate,
  strategyGoals,
  singleStrategyGoal,
  projectGoals,
  goalProjects,
  normalized,
  projectsList,
  projectOwners,
  exportRequests,
  yearTimePeriod,
  projectPermissions,
});

interface ThunkExtraArgument {
  requestsApi: () => RequestsApi;
  getUserSummariesApi: () => UserSummariesApi;
  getDashboardApi: () => DashboardAPI;
  getAgentDashboardApi: () => AgentDashboardApi;
  getCardTypeApi: () => CardTypeApi;
  getInsightDataApi: () => InsightDataApi;
  getInsightFiltersApi: () => insightFiltersAPI;
  getFormSummariesApi: () => FormSummariesApi;
  getProjectSummariesApi: () => ProjectSummariesApi;
  getProjectPermissionsApi: () => ProjectPermissionsApi;
  getRequestPermissionsApi: () => RequestPermissionsApi;
  getEventPermissionsApi: () => EventPermissionsApi;
  getProgramPermissionsApi: () => ProgramPermissionsApi;
  getBusinessUnitSummariesApi: () => BusinessUnitSummariesApi;
  getInsightDrilldownApi: () => InsightDrilldownApi;
  getLearningTeamsApi: () => LearningTeamsApi;
  getProjectTemplatesApi: () => ProjectTemplatesApi;
}

const extraArgument: ThunkExtraArgument = {
  requestsApi: () => BaseApiFactory.getRequestsApi(),
  getUserSummariesApi: () => BaseApiFactory.getUserSummariesApi(),
  getDashboardApi: () => BaseApiFactory.getDashboardApi(),
  getAgentDashboardApi: () => BaseApiFactory.getAgentDashboardApi(),
  getCardTypeApi: () => BaseApiFactory.getCardTypeApi(),
  getFormSummariesApi: () => BaseApiFactory.getFormSummariesApi(),
  getProjectSummariesApi: () => BaseApiFactory.getProjectSummariesApi(),
  getProjectPermissionsApi: () => BaseApiFactory.getProjectPermissionsApi(),
  getRequestPermissionsApi: () => BaseApiFactory.getRequestPermissionsApi(),
  getEventPermissionsApi: () => BaseApiFactory.getEventPermissionsApi(),
  getProgramPermissionsApi: () => BaseApiFactory.getProgramPermissionsApi(),
  getBusinessUnitSummariesApi: () => BaseApiFactory.getBusinessUnitsApi(),
  getInsightDataApi: () => BaseApiFactory.getInsightDataApi(),
  getInsightFiltersApi: () => BaseApiFactory.getInsightFiltersApi(),
  getInsightDrilldownApi: () => BaseApiFactory.getInsightDrilldownApi(),
  getLearningTeamsApi: () => BaseApiFactory.getLearningTeamsApi(),
  getProjectTemplatesApi: () => BaseApiFactory.getProjectTemplatesApi(),
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument,
      },
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type ThunkAppDispatch = ThunkDispatch<
  RootState,
  ThunkExtraArgument,
  Action
>;

export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>();

export interface ThunkApi {
  state: RootState;
  dispatch: ThunkAppDispatch;
  extra: ThunkExtraArgument;
}
